<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Dozwolone adresy IP</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/ips">Dozwolone adresy IP</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dozwolone adresy IP</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="ipObj.description"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Adres IP</label>
                <div class="col-sm-10">
                  <input
                    v-model="ipObj.ip"
                    name="ip"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Adres IP"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.ip" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.ip[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/ips">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddIp"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { allowedIpPermissionsConst } from "../../constants/ipConstants";

export default {
  name: "IpsCreate",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const ipObj = ref({
      ip: "",
      description: "",
    });

    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    const createIpData = computed(() => store.getters.getCreateIpData);

    const canAddIp = computed(() =>
      hasPermission(allowedIpPermissionsConst.add)
    );

    const create = () => {
      if (!canAddIp.value) {
        return;
      }

      showErrors.value = true;
      store.dispatch("createIp", ipObj.value);
    };

    watch(
      () => createIpData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "Ips", path: "/ips" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Adres IP został dodany",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      countryList,
      ipObj,
      errorsAdminData,
      showErrors,
      create,
      canAddIp,
    };
  },
  computed: {},
};
</script>
